const { SCHEMA_VERSION } = require('./constants');

function createReport(ctx, checks, now = new Date().toISOString()) {
  const report = {
    schemaVersion: SCHEMA_VERSION,
    generatedAt: now,
    sdkVersion: ctx.sdkVersion,
    merchant_id: ctx.merchant_id,
    shopOrigin: ctx.shopOrigin,
    ottuInstanceDomain: ctx.ottuInstanceDomain,
    checks,
  };
  if (ctx.lang) {
    report.lang = ctx.lang;
  }
  if (ctx.session_id) {
    report.session_id = ctx.session_id;
  }
  return report;
}

module.exports = { createReport };
